const CheckBadge = ({ color = 'white' }: { color: string }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.9905 23H23M22.9905 23C22.3678 23.6175 21.2393 23.4637 20.4479 23.4637C19.4765 23.4637 19.0087 23.6537 18.3154 24.347C17.7251 24.9374 16.9337 26 16 26C15.0663 26 14.2749 24.9374 13.6846 24.347C12.9913 23.6537 12.5235 23.4637 11.5521 23.4637C10.7607 23.4637 9.63218 23.6175 9.00949 23C8.38181 22.3776 8.53628 21.2444 8.53628 20.4479C8.53628 19.4414 8.31616 18.9786 7.59938 18.2618C6.53314 17.1956 6.00002 16.6624 6 16C6.00001 15.3375 6.53312 14.8044 7.59935 13.7382C8.2392 13.0983 8.53628 12.4643 8.53628 11.5521C8.53628 10.7607 8.38249 9.63214 9 9.00944C9.62243 8.38178 10.7556 8.53626 11.5521 8.53626C12.4643 8.53626 13.0983 8.2392 13.7382 7.59937C14.8044 6.53312 15.3375 6 16 6C16.6625 6 17.1956 6.53312 18.2618 7.59937C18.9015 8.23907 19.5355 8.53626 20.4479 8.53626C21.2393 8.53626 22.3679 8.38247 22.9906 9C23.6182 9.62243 23.4637 10.7556 23.4637 11.5521C23.4637 12.5586 23.6839 13.0214 24.4006 13.7382C25.4669 14.8044 26 15.3375 26 16C26 16.6624 25.4669 17.1956 24.4006 18.2618C23.6838 18.9786 23.4637 19.4414 23.4637 20.4479C23.4637 21.2444 23.6182 22.3776 22.9905 23Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M13 16.8929C13 16.8929 14.2 17.5447 14.8 18.5C14.8 18.5 16.6 14.75 19 13.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CheckBadge;
